import { APIClient } from "./apiCore";
import * as url from "./urls";
import { BasicDetailsTypes } from "../data/myProfile";
import { Utils } from "helpers/utils";
import { FrontEndApp } from "const";

const api = new APIClient();

// postForgetPwd
const postFakeForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// postForgetPwd
const postJwtForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

const postFakeLogin = (data: any) => api.create(url.POST_FAKE_LOGIN, data);

const postErpLogin = (data: any) => api.create(url.POST_ERP_LOGIN, data);

const postJwtLogin = (data: any) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// Register Method
const postFakeRegister = (data: any) => {
  return api.create(url.POST_FAKE_REGISTER, data);
};

// Register Method
const postJwtRegister = (data: any) => {
  return api.create(url.JWT_REGISTER, data);
};
const changePassword = (data: object) => {
  return api.update(url.USER_CHANGE_PASSWORD, data);
};

// postSocialLogin
const postSocialLogin = (data: any) => api.create(url.SOCIAL_LOGIN, data);

export interface ServiceResponse {
  data: any,
  message: string,
  success: boolean,
  tag: string | null,
}

export interface OtpStruct { mobile: string, otp: string, err: string, refno: string };
//const getOtp = async (mobileNo: string): Promise<OtpStruct> => await api.fnPost("/auth-register-phone-get-otp", { MobileNo: mobileNo }) as OtpStruct;
const getOtp = async (mobileNo: string, bIsRegister: boolean, inviteCode: any): Promise<OtpStruct> => api.fnPost("/auth-register-phone-get-otp", { mobileNo: mobileNo, isRegister: bIsRegister, inviteCode: inviteCode, deviceId: Utils.GetDeviceId(), frontEndVersion: Utils.APP_VERSION });
const verifyOtp = async (mobileNo: string, otp: string, bIsRegister: boolean, inviteCode: string): Promise<any> => api.fnPost("/auth-register-phone-verify-otp", { MobileNo: mobileNo, Otp: otp, isRegister: bIsRegister, inviteCode: inviteCode, frontEndApp: FrontEndApp.AppChat2S });

export enum UserTypes { Employee = 1, Customer = 2, Group = 3, Supplier = 4, GroupSupplier = 5, ExternalUser = 9 }
export enum UserRoles { User = 1, Admin = 2 }

export const UserTypeInfo = {
  BADGE: {
    Employee: 'primary',
    Customer: 'info',
    Group: 'secondary',
    Supplier: 'info'
  },
  BG: {
    Employee: 'bg-primary',
    Customer: 'bg-dark',
    Group: 'bg-secondary',
    Supplier: 'bg-dark'
  },
  TEXT: {
    Employee: process.env.REACT_APP_COMPANY_ABBR,
    Customer: 'ลูกค้า',
    Group: 'ห้องแชท',
    Supplier: 'SUP',
    GroupSupplier: 'ห้องแชท sup',
    ExternalUser: "External User",
  },
}

export const UserRoleInfo = {
  BADGE: { User: 'info', Admin: 'danger' },
  BG: { User: 'bg-secondary', Admin: 'bg-danger' },
  TEXT: { User: 'ผู้ใช้', Admin: 'ผู้ดูแล' }
}

export interface UserStruct {
  mobileNo?: string,
  userId?: number,
  userType?: number,
  isAdmin?: boolean,
  firstName?: string,
  lastName?: string,
  fullName?: string,
  nickName?: string,
  companyName?: string,
  pictureUrl?: string,
  lastLogonDate?: string,
  activeGroupI?: number,
  basicDetails?: BasicDetailsTypes
};

const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
  return window.btoa(binary);
};

const regisNewCus = async (data: UserStruct): Promise<ServiceResponse> => api.fnPost("/auth-register-phone-apply", data);
const getCurrentUser = async (): Promise<ServiceResponse> => {
  // const parm = await Utils.GetFCMTokenForApiParm();
  let parm = {};
  let errMsg = '';
  try {
    parm = await Utils.GetFCMTokenForApiParm(); // 20250729 sometime got exception from FCM on some blocked device. Then just ignore it to able to continue use program
  } catch (e) {
    Utils.HandleException(e, false);
    errMsg = Utils.GetMessageFromExecption(e);
  }

  // console.log('post getCurrentUser(me) with:', parm);
  const resp = api.fnPostForm("/me", parm);
  // console.log('/me:', resp);
  return resp;
}

const logoutCurrentUser = async (): Promise<any> => {
  // let parm = {
  //   endpoint: '', p256dh: '', auth: ''
  // };
  // if ('serviceWorker' in navigator && 'PushManager' in window) {
  //   if (navigator.serviceWorker.controller) {
  //     const registration = await navigator.serviceWorker.ready;
  //     const sub: PushSubscription | null = await registration.pushManager.getSubscription();
  //     if (sub) {
  //       parm = {
  //         endpoint: sub.endpoint,
  //         p256dh: arrayBufferToBase64(sub.getKey('p256dh') as ArrayBuffer),
  //         auth: arrayBufferToBase64(sub.getKey('auth') as ArrayBuffer)
  //       }
  //     }
  //   } else {
  //     console.log('Service worer not completedly installed');
  //   }
  // }
  // console.log('post me with:', parm);
  const parm = await Utils.GetFCMTokenForApiParm();
  return api.fnPostForm("/logout", parm);
  // api.fnGet("/logout");  
}


export {
  postFakeForgetPwd,
  postJwtForgetPwd,
  postFakeLogin,
  postErpLogin,
  postJwtLogin,
  postFakeRegister,
  postJwtRegister,
  changePassword,
  postSocialLogin,
  getOtp, verifyOtp, regisNewCus, getCurrentUser, logoutCurrentUser
};


